<template>
  <div :class="form_field_id ? 'form_field_dropdown' : 'dropdown'">
    <input
      v-if="Object.keys(selectedItem).length === 0"
      ref="dropdowninput"
      v-model.trim="inputValue"
      v-on:keyup="queryForKeywords"
      class="dropdown-input"
      type="text"
      placeholder="Stock code"
    />
    <div v-else @click="resetSelection" class="dropdown-selected">{{ selectedItem.stockCode }}</div>
    <div v-show="inputValue && apiLoaded" class="dropdown-list" style="z-index:10;">
      <div
        @click="selectItem(item);addItem()"
        v-for="item in itemList"
        :key="item.stockCode"
        class="dropdown-item"
      >{{ item.stockCode }} - {{ item.title }}</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: {
    form_submitted: {
      type: Boolean,
      default: false,
    },
    form_field_id: {
      type: String,
    },
  },
  data() {
    return {
      selectedItem: {},
      inputValue: "",
      itemList: [],
      apiLoaded: false,
      apiUrl: `api/retrieve-products`,
    };
  },
  mounted() {},
  methods: {
    queryForKeywords: function (event) {
      if (this.form_field_id) {
        this.$emit("product-search-selected", {
          data: {
            form_field_id: this.form_field_id,
            value: [],
          },
        });
      }

      this.$nextTick(() => {
        if (this.inputValue.length > 3) {
          this.getList();
        }
      });
    },
    addItem() {
      if (
        this.selectedItem &&
        this.selectedItem.stockCode &&
        this.selectedItem.stockCode.length > 0
      ) {
        this.$emit("on-new-item", this.selectedItem);
      }
      this.selectedItem = {};
    },
    resetSelection() {
      this.selectedItem = {};
      this.$nextTick(() => this.$refs.dropdowninput.focus());
      this.$emit("on-item-reset");
    },
    changedItem() {},
    selectItem(theItem) {
      if (this.form_field_id) {
        this.apiLoaded = false;
        this.inputValue = theItem.stockCode + " - " + theItem.title;
        this.$emit("product-search-selected", {
          data: {
            form_field_id: this.form_field_id,
            value: theItem.stockCode + " - " + theItem.title,
          },
        });
      } else {
        this.selectedItem = theItem;
        this.inputValue = "";
        this.$emit("on-item-selected", theItem);
      }
    },
    getList() {

     let parts_only = this.form_field_id ? 'true' : 'false';

      axios.get(this.apiUrl + "?value=" + this.inputValue+ "&parts_only=" +parts_only).then((response) => {
        this.itemList = response.data.data;
        this.apiLoaded = true;
      });
    },
  },
};
</script>

<style scoped>
.dropdown {
  position: relative;
  width: 100%;
  max-width: 400px;
  margin: 0 auto 10px;
}
.form_field_dropdown {
  position: relative;
  width: 100%;
  margin: 0 auto 10px;
}
.dropdown-input,
.dropdown-selected {
  padding: 10px 16px;
  border: 1px solid transparent;
  background: #edf2f7;
  line-height: 1.5em;
  outline: none;
  width: 100%;
}
.dropdown-input:focus,
.dropdown-selected:hover {
  background: #fff;
  border-color: #e2e8f0;
}
.dropdown-input::placeholder {
  opacity: 0.7;
}
.dropdown-selected {
  font-weight: bold;
  cursor: pointer;
  display: inline-block;
  width: 100%;
}
.dropdown-list {
  position: absolute;
  width: 100%;
  max-height: 500px;
  margin-top: 4px;
  overflow-y: auto;
  background: #ffffff;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  border: 1px solid #ccc;
}
.dropdown-item {
  display: flex;
  width: 100%;
  padding: 11px 16px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
}
.dropdown-item:hover {
  background: #edf2f7;
}
</style>
